import { Form, Select } from "antd";

const SelectField = ({ field, form, watchedValues }) => {
  // selectItems can be a static array, or a function of the form's other
  // live values — e.g. a "Unit" select whose options depend on the
  // currently chosen "Office".
  const resolvedItems =
    typeof field.selectItems === "function"
      ? field.selectItems(watchedValues)
      : field.selectItems;

  return (
    <Form.Item
      hidden={field?.hidden}
      name={field.name}
      label={field.label}
      extra={field.extra}
      rules={field.rules}
    >
      <Select
        placeholder={`Select ${field.label}`}
        options={resolvedItems?.map((item) => ({
          label: item.label,
          value: item.name,
        }))}
        disabled={field.disabled}
        showSearch={field.searchable}
        popupMatchSelectWidth={false}
        filterOption={
          field.searchable
            ? (input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            : undefined
        }
        onChange={
          field.resetFieldsOnChange?.length
            ? () => {
                const resetValues = {};
                field.resetFieldsOnChange.forEach((name) => {
                  resetValues[name] = null;
                });
                form?.setFieldsValue(resetValues);
              }
            : undefined
        }
      />
    </Form.Item>
  );
};

export default SelectField;
